// extracted by mini-css-extract-plugin
export default {"payment":"js","title_row":"ks","border_bottom":"ls","promo_wrapper":"ms","payment_wrapper":"ns","label":"os","card_row":"ps","cardcontain":"qs","card_input":"rs","card_error":"ss","card_label":"ts","lock":"us","same_address":"vs","place_order_button":"ws","buttonwrap":"xs","hide_form":"ys","paypal_buttons":"zs","review_button":"As","alt_payment":"Bs"};
    if(module.hot) {
      // 1730991502433
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  